import { localStorageGet } from "./LocalStorageHelper";
import { API_URL } from "../App";

export const dataURLtoFile = (
  dataUrl: string,
  filename: string,
  fileExt: string
) => {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], `${filename}.${fileExt}`, { type: mime });
};

export const downloadDocumentFile = (
  fileName: string,
  url: string,
  type: "pdf" | "xml" | "xlsx",
  apiUrl?: string,
  search?: any
): Promise<void> => {
  return new Promise<void>(function (resolve, reject) {
    let req = new XMLHttpRequest();
    const params =
      search &&
      Object.keys(search)
        .filter((key) => search[key] !== undefined && search[key] !== null)
        .map((key) => key + "=" + search[key])
        .join("&");

    req.open(
      "GET",
      `${apiUrl || API_URL}${url}${params ? `?${params}` : ""}`,
      true
    );
    req.setRequestHeader("Authorization", "Bearer " + localStorageGet("token"));
    req.responseType = "blob";

    req.onload = function () {
      if (req.status === 200) {
        var blob = req.response;
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${fileName}.${type}`;
        link.click();
        window.URL.revokeObjectURL(link.href);
        resolve();
      } else {
        reject(new Error(`Failed to download file: ${req.status}`));
      }
    };

    req.onerror = function () {
      reject(new Error("Network error while downloading file"));
    };

    req.send();
  });
};

export const helpFileUrl =
  "https://erpg.eagrar.gov.rs/upload/uputstvo-za-azuriranje.pdf";

export const helpVideoUrl = "https://youtu.be/zv39zORPfK0";
